import { render, staticRenderFns } from "./cardTemplateVip21.vue?vue&type=template&id=61734d7c&scoped=true&"
import script from "./cardTemplateVip21.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip21.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip21.vue?vue&type=style&index=0&id=61734d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61734d7c",
  null
  
)

export default component.exports